const API_BASE = '/api/brief';

export async function createBrief(formData) {
  const res = await fetch(API_BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      brandCore: formData.brandCore,
      visuals: formData.visuals,
      scales: formData.scales,
      _hp: formData._hp || ''
    })
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.details?.join(', ') || error.error);
  }

  return res.json();
}

export async function getBrief(id) {
  const res = await fetch(`${API_BASE}/${id}`);

  if (res.status === 404) {
    return null;
  }

  if (!res.ok) {
    throw new Error('Failed to fetch brief');
  }

  return res.json();
}

export async function updateBrief(id, formData) {
  const res = await fetch(`${API_BASE}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      brandCore: formData.brandCore,
      visuals: formData.visuals,
      scales: formData.scales
    })
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.details?.join(', ') || error.error);
  }

  return res.json();
}
